import { createContext } from "react";
import { Agency } from "../../../../types/global";

// @ts-ignore
export const AgencyContext = createContext<Agency>(null)